import { CARD_PAGE_SET_CARD_DETAILS, CARD_PAGE_SET_CARD_STATE, CARD_PAGE_SET_LOADING, CARD_PAGE_SET_TRANSACTIONS } from '@Actions/cardPageActions';
export const defaultState = {
    loading: true,
    details: null,
    transactions: [],
    count: 0
};
export function cardPageReducer(state = defaultState, action) {
    switch (action.type) {
        case CARD_PAGE_SET_LOADING:
            return Object.assign(Object.assign({}, state), { loading: action.payload });
        case CARD_PAGE_SET_CARD_DETAILS:
            return Object.assign(Object.assign({}, state), { details: action.payload });
        case CARD_PAGE_SET_TRANSACTIONS:
            return Object.assign(Object.assign({}, state), { transactions: action.payload.rows, count: action.payload.count });
        case CARD_PAGE_SET_CARD_STATE:
            return Object.assign(Object.assign({}, state), { details: Object.assign(Object.assign({}, state.details), { state: action.payload }) });
        default:
            return state;
    }
}
